var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowMoreInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.6331 18.6331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000010153"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13308",
    cx: 9.86209,
    cy: 9.31668,
    r: 6.24686,
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_ii_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31613 0C4.17144 0 0 4.17144 0 9.31613C0 14.4608 4.17144 18.6331 9.31613 18.6331C14.4608 18.6331 18.6331 14.4608 18.6331 9.31613C18.6331 4.17144 14.4608 0 9.31613 0ZM11.2874 14.3088C11.2674 14.3903 11.2091 14.4571 11.131 14.4877C10.7095 14.653 10.369 14.7803 10.108 14.871C9.78685 14.9758 9.45042 15.0262 9.11265 15.02C8.53216 15.02 8.08024 14.878 7.75845 14.5949C7.43666 14.3118 7.27655 13.9529 7.27655 13.5168C7.27655 13.3472 7.28838 13.1737 7.31204 12.997C7.34129 12.7958 7.37998 12.596 7.42798 12.3984L8.02818 10.2783C8.08103 10.0749 8.12677 9.88163 8.16305 9.70181C8.19933 9.52041 8.21668 9.35399 8.21668 9.20256C8.21668 8.93282 8.16069 8.74354 8.04948 8.63706C7.93669 8.53059 7.72453 8.47853 7.40826 8.47853C7.25368 8.47853 7.09436 8.5014 6.9311 8.54952C6.75329 8.60416 6.57374 8.44172 6.61763 8.26095L6.63887 8.17346C6.65993 8.08669 6.72135 8.01517 6.8043 7.98213C7.14959 7.84461 7.48175 7.72517 7.80025 7.62437C8.12841 7.51458 8.47166 7.45657 8.81767 7.45243C9.39421 7.45243 9.83904 7.59282 10.1522 7.87044C10.4637 8.14886 10.6206 8.51087 10.6206 8.9557C10.6206 9.04797 10.6096 9.21045 10.5883 9.44232C10.5698 9.659 10.5296 9.87329 10.4684 10.082L9.87138 12.1957C9.81786 12.3869 9.77391 12.5806 9.73966 12.7762C9.70716 12.9389 9.6879 13.104 9.68209 13.2699C9.68209 13.5507 9.7444 13.7423 9.87059 13.8441C9.9952 13.9458 10.2137 13.9971 10.5228 13.9971C10.6688 13.9971 10.832 13.971 11.0166 13.9206C11.1804 13.8754 11.3557 14.0307 11.3152 14.1957L11.2874 14.3088ZM11.1499 5.85926C10.8784 6.11526 10.5173 6.25458 10.1443 6.2473C9.75307 6.2473 9.41551 6.11795 9.13473 5.85926C9.00121 5.74181 8.89455 5.59697 8.82201 5.43461C8.74947 5.27224 8.71275 5.09616 8.71435 4.91834C8.71435 4.55159 8.85632 4.23611 9.13473 3.97505C9.40679 3.71701 9.76936 3.57623 10.1443 3.58307C10.5363 3.58307 10.8722 3.7132 11.1499 3.97505C11.4283 4.23611 11.5679 4.55159 11.5679 4.91834C11.5679 5.28666 11.4283 5.60056 11.1499 5.85926Z",
    fill: "url(#paint0_linear_0_4)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_0_4",
    x: -2,
    y: -2,
    width: 22.6331,
    height: 22.6331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_4"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_0_4",
    result: "effect2_innerShadow_0_4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 18.6331,
    y1: 9.31654,
    x2: 0,
    y2: 9.31654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowMoreInfoIcon);
export default __webpack_public_path__ + "static/media/know-more-info-icon.e2f64e3528c10040781ad5c6dcc78315.svg";
export { ForwardRef as ReactComponent };